export default __webpack_public_path__ + "static/media/htm.d87d2214.svg";